function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#cmlg)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M343.199 338.271V326.999L332.794 336.535L329.323 306.617L302.003 326.131L298.536 313.12L288.995 322.661V307.048L277.287 320.924L266.883 289.706L253.869 321.815L234.791 297.943L220.479 330.46V314.853L212.242 330.033L206.603 309.651L190.992 333.935L167.139 304.013L159.765 333.5L152.826 325.263L147.629 345.686H347.97L349.71 337.839L343.199 338.271Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M260.408 175.959C260.408 175.959 359.192 301.359 182.914 296.853L175.921 302.845V260.782L236.322 247.428L229.229 170.026",
  fill: "#E3AB4E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M234.209 224.37C252.447 225.328 267.052 249.65 267.052 279.519C267.052 280.171 267.052 280.824 267.03 281.476C253.581 290.127 232.55 295.947 200.854 296.856C199.705 291.147 199.131 285.337 199.141 279.513C199.103 271.162 200.309 262.852 202.717 254.856L236.338 247.423L234.209 224.37Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M251.526 178.145C251.526 178.145 258.246 287.843 239.259 339.779L243.225 345.604H209.484C209.484 345.604 205.795 206.075 205.795 175.959L251.526 178.145Z",
  fill: "#FEC85C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M225.872 93.2693V107.527L243.532 111.866V87.8077L225.872 83.4685V93.2693Z",
  fill: "#FFE5BB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M235.85 98.2012C236.111 98.2012 236.322 97.9899 236.322 97.7292C236.322 97.4686 236.111 97.2573 235.85 97.2573C235.59 97.2573 235.378 97.4686 235.378 97.7292C235.378 97.9899 235.59 98.2012 235.85 98.2012Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M228.594 98.2012C228.855 98.2012 229.066 97.9899 229.066 97.7292C229.066 97.4686 228.855 97.2573 228.594 97.2573C228.334 97.2573 228.122 97.4686 228.122 97.7292C228.122 97.9899 228.334 98.2012 228.594 98.2012Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.726 100.547V93.2682H227.077",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M236.741 93.2671H233.092",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M242.37 96.9973V99.5237C243.024 99.5237 243.652 99.2637 244.115 98.8009C244.578 98.3382 244.838 97.7105 244.838 97.0561V96.8386C244.798 96.5257 244.641 96.2397 244.397 96.0389C244.154 95.8381 243.844 95.7376 243.529 95.7578C243.214 95.7781 242.919 95.9176 242.704 96.1479C242.488 96.3782 242.369 96.682 242.37 96.9973V96.9973Z",
  fill: "#FFE5BB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M242.37 99.5248C243.024 99.5248 243.652 99.2648 244.115 98.802C244.578 98.3392 244.838 97.7116 244.838 97.0571",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M232.32 102.341C232.649 102.341 232.974 102.277 233.277 102.151C233.581 102.025 233.857 101.841 234.089 101.609C234.321 101.377 234.505 101.101 234.631 100.797C234.757 100.494 234.821 100.169 234.821 99.8401",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M225.873 107.526L243.534 111.865",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.726 100.551L232.32 100.942",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M260.408 137.376V175.941L205.886 189.339L205.763 146.417C205.762 139.015 208.242 131.827 212.809 126.002C217.375 120.177 223.762 116.052 230.95 114.286V114.286C234.451 113.423 238.103 113.368 241.629 114.125C245.155 114.882 248.462 116.431 251.301 118.656C254.139 120.88 256.435 123.721 258.013 126.964C259.591 130.206 260.411 133.765 260.41 137.372L260.408 137.376Z",
  fill: "#FA7E58"
}), /*#__PURE__*/React.createElement("path", {
  d: "M251.525 178.145C251.525 178.145 258.245 287.844 239.257 339.779",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M244.124 95.8489C244.124 95.8489 246.496 87.984 242.761 84.7399C239.027 81.4958 222.452 82.3277 222.452 82.3277C222.452 82.3277 221.288 93.8142 238.354 91.0693C238.354 91.0693 238.604 94.2492 241.435 94.8136",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M214.091 168.167L214.391 168.113L252.684 161.066C254.424 157.517 257.595 156.404 259.149 156.785C260.703 157.166 257.541 159.816 257.378 159.965",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M257.372 159.953C265.586 155.296 272.239 158.626 270.462 162.62C269.87 163.495 269.174 164.296 268.39 165.005C257.149 176.12 204.553 217.337 200.333 178.141C199.794 173.307 199.632 168.438 199.847 163.579C201.346 131.206 220.578 118.862 220.578 118.862",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M259.299 157.567H297.769L314.639 118.571",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M312.275 122.778L252.679 90.4831",
  stroke: "#FA7E58",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M253.06 120.211C253.06 120.211 266.713 133.096 270.752 157.567",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M289.776 157.567C289.776 157.567 280.004 185.255 268.659 187.974",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M274.455 157.567C274.455 157.567 279.276 150.852 282.47 149.302C285.664 147.752 295.319 151.301 294.097 152.964C292.875 154.626 290.657 153.74 290.657 153.74C290.657 153.74 291.212 155.403 290.203 155.849",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M480.727 307.845C479.275 303.774 475.012 309.15 475.012 309.15C475.012 309.15 480.143 298.25 475.012 295.774C472.477 294.553 471.171 295.991 470.444 297.755C473.072 281.9 473.64 251.328 463.039 250.261C451.464 249.101 455.427 278.467 455.427 278.467C455.427 278.467 452.232 270.017 448.16 273.812C444.088 277.608 451.939 302.306 451.939 302.306C451.064 299.686 446.415 297.651 444.672 302.306C442.929 306.96 449.619 316.847 449.619 316.847L472.594 320.626C472.594 320.626 482.179 311.916 480.727 307.845Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M479.014 345.069H446.123L438.847 315.672H486.288L479.014 345.069Z",
  fill: "#FF6498"
}), /*#__PURE__*/React.createElement("path", {
  d: "M438.847 315.672H486.288",
  stroke: "black",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M363.345 270.989V335.998L359.059 345.231H388.471L397.997 254.16L363.345 270.989Z",
  fill: "#FFC9BD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M369.882 176.284L415.541 173.642V345.231H384.677L388.471 338.433L369.882 176.284Z",
  fill: "#FFC9BD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M372.118 95.1638V101.263C372.11 103.56 372.874 105.794 374.288 107.605C375.702 109.416 377.684 110.699 379.914 111.248L389.624 113.598V89.7816L381.55 87.8002C380.431 87.5263 379.265 87.5096 378.139 87.7512C377.013 87.9929 375.957 88.4866 375.049 89.1953C374.141 89.904 373.406 90.8093 372.898 91.843C372.391 92.8768 372.124 94.0121 372.118 95.1638V95.1638Z",
  fill: "#FFC9BD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M372.118 101.243C372.11 103.541 372.874 105.774 374.288 107.585C375.702 109.396 377.684 110.679 379.914 111.229L389.624 113.603",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M382.012 100.03C382.271 100.03 382.481 99.8206 382.481 99.5617C382.481 99.3028 382.271 99.093 382.012 99.093C381.753 99.093 381.544 99.3028 381.544 99.5617C381.544 99.8206 381.753 100.03 382.012 100.03Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M374.822 100.03C375.08 100.03 375.29 99.8206 375.29 99.5617C375.29 99.3028 375.08 99.093 374.822 99.093C374.563 99.093 374.353 99.3028 374.353 99.5617C374.353 99.8206 374.563 100.03 374.822 100.03Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M376.927 102.354V95.1442H373.316",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M382.888 95.1431H379.277",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M388.472 98.8396V101.313C389.115 101.311 389.731 101.056 390.186 100.603C390.642 100.15 390.901 99.5354 390.907 98.8929C390.907 98.816 390.907 98.7435 390.907 98.6754C390.873 98.3614 390.719 98.0727 390.477 97.8699C390.235 97.6671 389.924 97.5661 389.609 97.5879C389.294 97.6097 388.999 97.7527 388.787 97.9869C388.575 98.2211 388.462 98.5283 388.472 98.844V98.8396Z",
  fill: "#FFC9BD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M388.472 101.313C389.115 101.311 389.731 101.056 390.186 100.603C390.642 100.15 390.901 99.5354 390.907 98.8929",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M378.901 104.754C379.052 104.906 379.231 105.027 379.429 105.11C379.627 105.192 379.839 105.235 380.053 105.235C380.267 105.235 380.48 105.192 380.677 105.11C380.875 105.027 381.055 104.906 381.205 104.754",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M376.927 102.358L378.509 102.749",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M390.239 103.11C390.239 103.46 390.136 103.802 389.942 104.092C389.747 104.383 389.471 104.609 389.148 104.743C388.826 104.877 388.47 104.912 388.127 104.844C387.785 104.775 387.47 104.607 387.223 104.36C386.975 104.113 386.807 103.798 386.739 103.455C386.671 103.112 386.706 102.757 386.84 102.434C386.973 102.111 387.2 101.835 387.49 101.641C387.781 101.447 388.123 101.343 388.472 101.343",
  stroke: "#FF6498",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M372.118 104.465C371.898 104.639 371.64 104.758 371.364 104.812C371.089 104.867 370.805 104.855 370.536 104.777C370.266 104.7 370.019 104.559 369.814 104.368C369.609 104.176 369.453 103.938 369.359 103.674C369.264 103.41 369.234 103.127 369.271 102.849C369.307 102.571 369.409 102.306 369.568 102.075C369.728 101.844 369.94 101.654 370.187 101.522C370.434 101.389 370.709 101.317 370.989 101.312",
  stroke: "#FF6498",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M415.542 138.874V177.097L361.395 190.417V147.838C361.396 140.504 363.855 133.382 368.38 127.611C372.905 121.839 379.234 117.751 386.356 116V116C389.826 115.145 393.445 115.091 396.939 115.842C400.433 116.592 403.711 118.128 406.524 120.333C409.336 122.537 411.611 125.353 413.174 128.567C414.738 131.78 415.55 135.307 415.549 138.881L415.542 138.874Z",
  fill: "#EE5A98"
}), /*#__PURE__*/React.createElement("path", {
  d: "M415.542 177.098L361.395 190.403V274.123L443.687 261.165L415.542 177.098Z",
  fill: "#FA7E58"
}), /*#__PURE__*/React.createElement("path", {
  d: "M384.677 345.231L388.471 338.433L378.009 247.215",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M407.806 121.392C407.806 121.392 433.662 143.729 416.724 174.962C399.786 206.195 345.232 161.542 344.571 158.024C343.91 154.506 349.634 153.623 354.468 156.264C354.468 156.264 353.807 152.661 356.449 153.691C358.209 154.554 359.61 156.009 360.405 157.801L397.584 159.337L392.744 138.881",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M372.756 158.325L356.413 115.3L319.02 125.471L342.118 177.098L362.781 172.912",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M368.746 176.499C368.746 176.499 389.609 203.553 420.45 191.739L415.447 177.037C405.402 191.953 385.069 185.709 368.746 176.499Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M372.471 123.266L362.762 132",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M327.88 145.266C327.88 145.266 321.734 168.203 336.33 177.935C350.925 187.667 361.395 180.437 361.395 180.437",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M372.119 96.8038C370.878 96.2057 369.866 95.219 369.236 93.9935C368.607 92.7679 368.395 91.3705 368.631 90.0133C369.399 85.0813 383.857 71.6472 393.604 84.5289C403.352 97.4106 419.491 121.75 419.491 121.75L408.844 123.382C406.408 123.756 403.92 123.598 401.551 122.921C399.182 122.243 396.988 121.061 395.118 119.456C393.248 117.851 391.748 115.861 390.719 113.621C389.691 111.382 389.159 108.947 389.16 106.483V99.776",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M371.949 94.9909C371.949 94.9909 376.558 92.5711 377.381 88.4842C377.388 88.454 377.405 88.4272 377.429 88.408C377.454 88.3887 377.484 88.3783 377.515 88.3783C377.546 88.3783 377.576 88.3887 377.6 88.408C377.625 88.4272 377.642 88.454 377.649 88.4842C378.218 90.259 380.585 94.9213 389.794 96.0349",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.4109 165.161C85.4109 165.161 88.9138 183.858 76.4932 180.992C64.0726 178.127 54.2707 138.844 63.6724 134.337C73.074 129.831 85.4033 139.077 84.3201 144.839C83.9193 148.152 83.8464 151.497 84.1026 154.824",
  stroke: "black",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.1472 331.826C59.1472 277.933 89.3042 188.244 89.3042 188.244L108.445 174.701L118.341 235.269L84.431 345.807L51.6965 336.511L59.1472 331.826Z",
  fill: "#CA256A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.054 243.92C93.054 222.93 100.62 204.668 111.781 195.18L118.333 235.27L103.631 283.21C97.0941 273.139 93.054 259.252 93.054 243.92Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.9315 173.879L137.246 171.183L144.397 174.094L147.751 345.807H111.236L115.1 338.885L97.9315 173.879Z",
  fill: "#FF6498"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.048 91.3248V97.4704C125.048 99.803 124.266 102.068 122.827 103.904C121.388 105.739 119.374 107.039 117.109 107.595L107.232 110.053V85.7948L115.444 83.7742C116.585 83.4934 117.776 83.476 118.925 83.7232C120.074 83.9704 121.152 84.4758 122.077 85.201C123.002 85.9263 123.75 86.8524 124.264 87.9094C124.779 88.9664 125.046 90.1265 125.046 91.302L125.048 91.3248Z",
  fill: "#F9C5DB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.048 97.4715C125.048 99.8041 124.266 102.069 122.827 103.905C121.388 105.74 119.374 107.04 117.109 107.596L107.234 110.054",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.984 96.2731C115.247 96.2731 115.46 96.0598 115.46 95.7967C115.46 95.5337 115.247 95.3204 114.984 95.3204C114.721 95.3204 114.508 95.5337 114.508 95.7967C114.508 96.0598 114.721 96.2731 114.984 96.2731Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.296 96.2731C122.559 96.2731 122.773 96.0598 122.773 95.7967C122.773 95.5337 122.559 95.3204 122.296 95.3204C122.033 95.3204 121.82 95.5337 121.82 95.7967C121.82 96.0598 122.033 96.2731 122.296 96.2731Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.154 98.6384V91.3031H123.83",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.086 91.3031H117.765",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.41 95.0583V97.6118C107.75 97.6118 107.116 97.3495 106.65 96.8827C106.183 96.4158 105.92 95.7827 105.92 95.1224C105.92 95.0456 105.92 94.9731 105.92 94.9049C105.946 94.5781 106.099 94.2745 106.347 94.0599C106.595 93.8452 106.917 93.7367 107.245 93.7579C107.572 93.779 107.877 93.9281 108.095 94.1729C108.313 94.4177 108.426 94.7385 108.41 95.0659V95.0583Z",
  fill: "#F9C5DB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.41 97.6107C107.75 97.6107 107.116 97.3484 106.65 96.8816C106.183 96.4148 105.92 95.7816 105.92 95.1214",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M118.142 99.4987C117.834 99.7989 117.42 99.9668 116.99 99.9668C116.559 99.9668 116.146 99.7989 115.838 99.4987",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.153 98.646L118.54 99.0375",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M144.412 135.802V174.702L89.3129 188.244V144.928C89.3135 137.465 91.8161 130.217 96.4206 124.344C101.025 118.47 107.466 114.31 114.713 112.528V112.528C118.243 111.661 121.923 111.607 125.477 112.371C129.03 113.135 132.363 114.698 135.224 116.94C138.085 119.182 140.398 122.045 141.99 125.312C143.581 128.58 144.409 132.167 144.41 135.801L144.412 135.802Z",
  fill: "#AD7FE1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.423 94.9691C116.751 93.8403 115.437 86.7496 115.437 86.7496C115.437 86.7496 116.167 93.9697 107.548 94.3623",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.542 102.403C107.542 102.403 96.123 88.9377 109.616 80.7334C121.046 73.82 132.115 88.6147 130.517 95.7967C128.919 102.979 123.804 102.387 123.804 102.387",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.253 94.9669C131.986 97.0142 131.174 98.9522 129.903 100.579",
  stroke: "#FF6498",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.489 96.2741C133.489 96.2741 142.038 95.6825 143.299 103.072C144.559 110.462 146.996 110.055 146.996 110.055C146.996 110.055 131.933 112.836 130.704 101.246",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.099 338.885L99.1909 186",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.521 139.977L129.034 142.428L136.822 150.033L132.053 150.371C118.51 151.35 80.7214 154.212 79.0499 155.648C77.0369 157.438 83.7513 160.572 83.7513 160.572V160.695C84.1874 162.983 85.1529 165.138 86.5707 166.987C87.9885 168.836 89.8192 170.327 91.9164 171.342C107.84 178.962 128.412 178.654 144.35 174.283C157.801 170.604 167.964 164.044 169.293 156.923C169.604 155.283 169.427 153.587 168.786 152.046C165.06 142.828 157.203 134.463 150.159 128.317C145.813 124.514 141.191 121.037 136.332 117.916",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.046 150.366L126.523 139.973L129.035 142.423L136.824 150.028L132.046 150.366Z",
  fill: "black",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M144.412 174.287V174.655C128.604 178.773 108.539 184.741 92.9463 177.275C91.6222 176.641 90.4002 175.812 89.3205 174.817V169.678C90.1478 170.319 91.0414 170.871 91.986 171.322C107.887 178.973 128.45 178.665 144.412 174.287Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.192 121.214C99.192 121.214 90.6429 130.555 84.0058 148.253",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.5397 196.793C86.5397 196.793 70.7771 195.256 60.0313 175.792C49.2855 156.327 59.5321 139.435 60.0313 145.289C60.5305 151.143 60.6153 151.734 60.6153 151.734",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.4507 146.019C79.4093 146.019 80.1864 144.942 80.1864 143.614C80.1864 142.286 79.4093 141.21 78.4507 141.21C77.4921 141.21 76.715 142.286 76.715 143.614C76.715 144.942 77.4921 146.019 78.4507 146.019Z",
  fill: "#FA7E58"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.4062 142.908C73.3648 142.908 74.1419 141.832 74.1419 140.504C74.1419 139.176 73.3648 138.099 72.4062 138.099C71.4477 138.099 70.6706 139.176 70.6706 140.504C70.6706 141.832 71.4477 142.908 72.4062 142.908Z",
  fill: "#AD7FE1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.0758 144.206C67.0344 144.206 67.8115 143.129 67.8115 141.801C67.8115 140.473 67.0344 139.397 66.0758 139.397C65.1172 139.397 64.3401 140.473 64.3401 141.801C64.3401 143.129 65.1172 144.206 66.0758 144.206Z",
  fill: "#C6E648"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.4199 152.433C68.3785 152.433 69.1556 151.356 69.1556 150.028C69.1556 148.7 68.3785 147.624 67.4199 147.624C66.4614 147.624 65.6843 148.7 65.6843 150.028C65.6843 151.356 66.4614 152.433 67.4199 152.433Z",
  fill: "white",
  stroke: "black",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.6138 35.7349C24.8626 35.7278 21.1467 36.4597 17.6785 37.8889C14.2102 39.3181 11.0574 41.4166 8.40024 44.0644C5.74308 46.7123 3.63359 49.8577 2.19226 53.321C0.750929 56.7842 0.00599263 60.4975 0 64.2487L57.12 64.3488C57.1272 60.5982 56.3955 56.883 54.9668 53.4152C53.5381 49.9474 51.4403 46.7949 48.7932 44.1379C46.1462 41.4808 43.0017 39.3712 39.5393 37.9294C36.0769 36.4876 32.3644 35.7419 28.6138 35.7349V35.7349Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.1134 48.1251C83.7948 48.1176 79.6501 49.8258 76.5909 52.874C73.5317 55.9222 71.8086 60.0607 71.8005 64.3792L104.37 64.4412C104.377 60.1227 102.669 55.978 99.6208 52.9188C96.5726 49.8596 92.4341 48.1364 88.1155 48.1284L88.1134 48.1251Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.1744 34.4832C53.2491 34.4711 49.3599 35.2328 45.7292 36.7249C42.0986 38.217 38.7977 40.4102 36.0153 43.1791C33.2329 45.9479 31.0237 49.2381 29.5139 52.8614C28.0041 56.4848 27.2234 60.3702 27.2164 64.2955L86.9475 64.4043C86.9623 56.4898 83.8349 48.8931 78.2524 43.2829C72.6699 37.6727 65.0888 34.5077 57.1744 34.4832V34.4832Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M191.799 71.0153C193.964 71.0113 196.109 71.4342 198.11 72.2598C200.111 73.0854 201.93 74.2975 203.463 75.8268C204.995 77.3561 206.211 79.1725 207.041 81.1721C207.871 83.1718 208.298 85.3154 208.299 87.4804H175.361C175.362 83.1187 177.094 78.9355 180.175 75.8487C183.257 72.7619 187.437 71.0237 191.799 71.0153V71.0153Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M307.322 1.1082C310.648 1.10205 313.942 1.75172 317.016 3.02004C320.09 4.28836 322.883 6.15042 325.237 8.49966C327.591 10.8489 329.458 13.6392 330.732 16.7109C332.006 19.7826 332.662 23.0753 332.662 26.4007H282.081C282.081 19.7016 284.739 13.2761 289.471 8.53426C294.203 3.79245 300.623 1.12174 307.322 1.1082V1.1082Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M413.459 20.8946C409.172 20.8866 404.925 21.7241 400.962 23.3592C396.999 24.9944 393.397 27.395 390.362 30.4238C387.328 33.4525 384.92 37.05 383.278 41.0102C381.635 44.9704 380.79 49.2156 380.79 53.5029H446.008C446.008 44.865 442.58 36.58 436.478 30.4665C430.376 24.3529 422.097 20.9104 413.459 20.8946V20.8946Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.471 78.1604C158.704 78.1582 159.925 78.3989 161.065 78.8687C162.205 79.3385 163.241 80.0282 164.114 80.8984C164.987 81.7686 165.68 82.8023 166.154 83.9404C166.627 85.0785 166.872 86.2988 166.874 87.5315H148.092C148.097 85.0461 149.086 82.6637 150.844 80.9069C152.603 79.1501 154.986 78.1624 157.471 78.1604V78.1604Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M254.606 12.0791C258.429 12.0731 262.098 13.5859 264.806 16.285C267.514 18.984 269.038 22.6482 269.045 26.4714H240.201C240.207 22.6541 241.727 18.9951 244.428 16.297C247.128 13.5989 250.788 12.082 254.606 12.0791V12.0791Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M481.431 35.04C478.99 35.036 476.572 35.5128 474.316 36.4431C472.059 37.3735 470.008 38.7391 468.279 40.4621C466.551 42.1852 465.178 44.2318 464.241 46.4852C463.303 48.7386 462.818 51.1546 462.814 53.5954H500.001C499.993 48.674 498.033 43.9568 494.552 40.4783C491.071 36.9998 486.352 35.0441 481.431 35.04V35.04Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.331 70.2943C177.592 70.2903 179.833 70.7318 181.924 71.5936C184.015 72.4554 185.915 73.7206 187.517 75.317C189.119 76.9133 190.391 78.8096 191.261 80.8976C192.13 82.9855 192.579 85.2242 192.583 87.4859L158.139 87.5479C158.135 85.2861 158.576 83.0457 159.438 80.9546C160.3 78.8635 161.565 76.9626 163.161 75.3604C164.758 73.7582 166.654 72.4862 168.742 71.617C170.83 70.7477 173.069 70.2983 175.331 70.2943Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M282.033 1.08904e-05C285.507 -0.00613537 288.947 0.672001 292.159 1.9957C295.37 3.31939 298.289 5.26271 300.75 7.7147C303.21 10.1667 305.163 13.0793 306.498 16.2862C307.833 19.4931 308.523 22.9315 308.528 26.4051L255.631 26.4997C255.624 23.0261 256.302 19.5851 257.625 16.3734C258.949 13.1616 260.892 10.242 263.343 7.78121C265.795 5.32043 268.707 3.3667 271.914 2.03159C275.121 0.696483 278.559 0.00614613 282.033 1.08904e-05V1.08904e-05Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M446.07 19.4656C441.592 19.4576 437.156 20.3317 433.016 22.038C428.875 23.7444 425.112 26.2495 421.94 29.4104C418.767 32.5712 416.249 36.326 414.528 40.4602C412.807 44.5943 411.917 49.027 411.909 53.5051L480.108 53.6269C480.116 49.1489 479.242 44.7132 477.535 40.5731C475.829 36.433 473.324 32.6695 470.163 29.4975C467.002 26.3255 463.247 23.8072 459.113 22.0863C454.979 20.3654 450.547 19.4756 446.069 19.4678L446.07 19.4656Z",
  fill: "#EDEEEF"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "cmlg"
}, /*#__PURE__*/React.createElement("rect", {
  width: 500,
  height: 345.971,
  fill: "white"
})));

var SvgCommunityLg = function SvgCommunityLg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 346,
    viewBox: "0 0 500 346",
    fill: "none",
    className: "md:absolute bottom-0 md:right-0 md:bottom-0 md:mr-35 h-40 sm:h-auto md:w-128 transform translate-y-10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCommunityLg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CommunityLg.6c7f9a69.svg";
export { ForwardRef as ReactComponent };